export enum TaskTab {
  Todo = "todo",
  InProgress = "in-progress",
  All = "all",
}
